import type {
  Configuration,
  CreateMPAPolicyRequest,
  MPAOperationType,
  UpdateMPAPolicyRequest,
} from '@repo/api-gw-sdk';
import { MpaApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/mpa';

export const mpa = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const mpaApi = new MpaApi(config);

  return {
    operations: {
      useList: () =>
        httpClient.execute(
          mpaApi.listMPAOperations.bind(mpaApi),
          baseUrl,
          'operations'
        ),
    },
    policies: {
      useList: (operation?: MPAOperationType) =>
        httpClient.execute(
          mpaApi.listMPAPolicies.bind(mpaApi),
          baseUrl,
          'policies',
          currentProjectId,
          operation
        ),
      create: (body: CreateMPAPolicyRequest) =>
        mpaApi.createMPAPolicy(currentProjectId, body),
      update: (mpaPolicyId: string, body: UpdateMPAPolicyRequest) =>
        mpaApi.updateMPAPolicy(currentProjectId, mpaPolicyId, body),
      delete: (mpaPolicyId: string) =>
        mpaApi.deleteMPAPolicy(currentProjectId, mpaPolicyId),
    },
  };
};
